import {
  Modal,
  ModalOverlay,
  ModalCloseButton,
  ModalContent,
  ModalBody,
  Stack,
  ModalHeader,
  Heading,
  Button,
  useDisclosure,
} from "@chakra-ui/react";
import { Translator } from "../Language";
import { Link } from "react-router-dom";

export function QuestionnaireTypeSelection() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button onClick={onOpen} variant="primary" size="large">
        <Translator path={"survey.newResearch.title"} />
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="3xl">
        <ModalOverlay />
        <ModalContent
          maxW="668px"
          height="568px"
          borderRadius="32px"
          overflow="hidden"
          p="88px"
        >
          <ModalHeader p="0 36px 32px">
            <Heading fontSize="24px" textAlign="center" lineHeight="28.18px">
              Selecione o tipo de questionário que você deseja cadastrar
            </Heading>
            <ModalCloseButton
              top="32px"
              right="32px"
              bg="#E5E5E5"
              rounded="full"
            />
          </ModalHeader>
          <ModalBody p={0}>
            <Stack spacing="3">
              <LinkBoxHover
                type="Questionário simples"
                path="/researches/register/simple"
              />
              <LinkBoxHover
                type="Questionário de Diagnóstico ESG"
                path="/researches/register/diagnosis"
              />
              <LinkBoxHover
                type="Questionário periódico"
                path="/researches/register/periodic"
              />
              <LinkBoxHover
                type="Questionário de Certificação"
                path="/researches/register/certification"
              />
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

const LinkBoxHover = ({ type, path }) => {
  return (
    <Button
      as={Link}
      to={path}
      h="67px"
      color="#0073BB"
      bg="rgba(0, 115, 187, 0.1)"
      fontWeight={600}
      borderRadius="8px"
      _hover={{
        color: "white",
        bg: "#0073BB",
      }}
    >
      {type}
    </Button>
  );
};
